/* tslint:disable */
/* eslint-disable */
/**
 * BlackFriday API
 * The API Documentation for BlackFriday
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import type { DataWarehouseProductDTO } from "./DataWarehouseProductDTO";
import {
  DataWarehouseProductDTOFromJSON,
  DataWarehouseProductDTOFromJSONTyped,
  DataWarehouseProductDTOToJSON
} from "./DataWarehouseProductDTO";
import type { UserRoleDTO } from "./UserRoleDTO";
import { UserRoleDTOFromJSON, UserRoleDTOFromJSONTyped, UserRoleDTOToJSON } from "./UserRoleDTO";

/**
 *
 * @export
 * @interface OutPublicUserWithDataWarehouseProductsDTO
 */
export interface OutPublicUserWithDataWarehouseProductsDTO {
  /**
   *
   * @type {UserRoleDTO}
   * @memberof OutPublicUserWithDataWarehouseProductsDTO
   */
  role: UserRoleDTO;
  /**
   *
   * @type {string}
   * @memberof OutPublicUserWithDataWarehouseProductsDTO
   */
  company?: string;
  /**
   *
   * @type {string}
   * @memberof OutPublicUserWithDataWarehouseProductsDTO
   */
  firstName?: string;
  /**
   *
   * @type {string}
   * @memberof OutPublicUserWithDataWarehouseProductsDTO
   */
  lastName?: string;
  /**
   *
   * @type {string}
   * @memberof OutPublicUserWithDataWarehouseProductsDTO
   */
  email: string;
  /**
   *
   * @type {string}
   * @memberof OutPublicUserWithDataWarehouseProductsDTO
   */
  phone?: string;
  /**
   *
   * @type {number}
   * @memberof OutPublicUserWithDataWarehouseProductsDTO
   */
  id: number;
  /**
   *
   * @type {Array<DataWarehouseProductDTO>}
   * @memberof OutPublicUserWithDataWarehouseProductsDTO
   */
  dataWarehouseProduct: Array<DataWarehouseProductDTO>;
}

/**
 * Check if a given object implements the OutPublicUserWithDataWarehouseProductsDTO interface.
 */
export function instanceOfOutPublicUserWithDataWarehouseProductsDTO(value: object): boolean {
  let isInstance = true;
  isInstance = isInstance && "role" in value;
  isInstance = isInstance && "email" in value;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "dataWarehouseProduct" in value;

  return isInstance;
}

export function OutPublicUserWithDataWarehouseProductsDTOFromJSON(
  json: any
): OutPublicUserWithDataWarehouseProductsDTO {
  return OutPublicUserWithDataWarehouseProductsDTOFromJSONTyped(json, false);
}

export function OutPublicUserWithDataWarehouseProductsDTOFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): OutPublicUserWithDataWarehouseProductsDTO {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    role: UserRoleDTOFromJSON(json["role"]),
    company: !exists(json, "company") ? undefined : json["company"],
    firstName: !exists(json, "firstName") ? undefined : json["firstName"],
    lastName: !exists(json, "lastName") ? undefined : json["lastName"],
    email: json["email"],
    phone: !exists(json, "phone") ? undefined : json["phone"],
    id: json["id"],
    dataWarehouseProduct: (json["dataWarehouseProduct"] as Array<any>).map(DataWarehouseProductDTOFromJSON)
  };
}

export function OutPublicUserWithDataWarehouseProductsDTOToJSON(
  value?: OutPublicUserWithDataWarehouseProductsDTO | null
): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    role: UserRoleDTOToJSON(value.role),
    company: value.company,
    firstName: value.firstName,
    lastName: value.lastName,
    email: value.email,
    phone: value.phone,
    id: value.id,
    dataWarehouseProduct: (value.dataWarehouseProduct as Array<any>).map(DataWarehouseProductDTOToJSON)
  };
}
